import {StyleParamType, createStylesParams} from '@wix/tpa-settings'

import {Alignment} from '../../../../../../types/createStylesParams'

export type AboutSectionStylesParams = {
  aboutSectionAlignment: StyleParamType.Number
}

export const aboutSectionStylesParams = createStylesParams<AboutSectionStylesParams>({
  aboutSectionAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Left,
  },
})
